import React from "react"
import SettingsNavigation from './SettingsNavigation'

class Settings extends React.Component {
  render() {
    return (
      <div className="block sm:flex overflow-y-scroll scrolling-smooth h-full">
        <SettingsNavigation/>
        <div className="w-full h-full mt-0">
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default Settings
